import { Entity } from './entity';
import { ICourseLog } from '@core/interfaces';
import { v4 as uuid } from 'uuid';
import { User } from './user.entity';

export class CourseLog extends Entity<ICourseLog> {
  constructor(props: ICourseLog) {
    super(props);
  }

  get id() {
    return uuid();
  }

  get user() {
    return this.props.user && new User(this.props.user);
  }

  get action() {
    return this.props.action;
  }

  get created() {
    return this.props.created;
  }

  getLocaleCreated(locale: string | string[]) {
    return (
      this.props.created &&
      new Date(this.props.created).toLocaleString(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    );
  }

  get message() {
    return this.props.message;
  }
}
